import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

import {IGroupedDevice} from '../../../shared';
import {Device} from '../../../afb-api/models/device';

@Component({
  selector: 'awair-device-add-dialog',
  templateUrl: './device-add-dialog.component.html',
  styleUrls: ['./device-add-dialog.component.scss']
})

export class DeviceAddDialogComponent implements OnInit {

  unassignedGroup: IGroupedDevice;
  selectedGroupName: string;

  isAllChecked: boolean;
  selectedDeviceList: Device[] = [];
  deviceWithCheckList: IDeviceWithCheck[] = [];

  constructor(private myDialogRef: MatDialogRef<DeviceAddDialogComponent>) {
  }

  ngOnInit() {
    // Create deviceWithCheckList
    // Always initialize when new group enters
    this.isAllChecked = false;
    this.deviceWithCheckList = [];
    this.selectedDeviceList = [];
    for (let i = 0; i < this.unassignedGroup.deviceList.length; i++) {
      this.deviceWithCheckList.push(Object.assign({}, this.unassignedGroup.deviceList[i], {checked: false}));
    }
  }

  onCancel(): void {
    this.myDialogRef.close();
  }

  onAdd(): void {
    this.myDialogRef.close(this.selectedDeviceList);
  }

  selectAllCheck(isAllChecked: boolean): void {
    this.isAllChecked = !isAllChecked;

    if (this.isAllChecked) {
      // When selected all, set every element's checked in deviceWithCheckList to true
      // and store modified list (objs without checked property) to selectedDeviceList
      const tempSelectedDeviceList: Device[] = [];
      this.deviceWithCheckList.forEach((deviceWithCheck: IDeviceWithCheck) => {
        deviceWithCheck.checked = this.isAllChecked;
        const copySelectedDevice: IDeviceWithCheck = Object.assign({}, deviceWithCheck);
        delete copySelectedDevice.checked;
        tempSelectedDeviceList.push(copySelectedDevice);
      });
      this.selectedDeviceList = tempSelectedDeviceList;

    } else {
      // When select all set to false, set checked property to false and assign empty array to selectedDevieList
      this.deviceWithCheckList.forEach((deviceWithCheck: IDeviceWithCheck) => {
        deviceWithCheck.checked = this.isAllChecked;
      });
      this.selectedDeviceList = [];
    }
  }

  selectDevice(selectedDevice: IDeviceWithCheck): void {
    const index = this.getDeviceIndex(this.selectedDeviceList, selectedDevice);

    if (selectedDevice.checked) {
      selectedDevice.checked = false;
      this.selectedDeviceList.splice(index, 1);

    } else {
      selectedDevice.checked = true;
      const copySelectedDevice: IDeviceWithCheck = Object.assign({}, selectedDevice);
      delete copySelectedDevice.checked;
      this.selectedDeviceList.push(copySelectedDevice);
    }

    // To automatically set allCheck checkbox
    this.isAllChecked = this.selectedDeviceList.length === this.unassignedGroup.deviceList.length ? true : false;
  }

  private getDeviceIndex(deviceList: Device[], selectedDevice: Device): number {
    return deviceList.findIndex((device: Device) => {
      return device.deviceId === selectedDevice.deviceId && device.deviceType === selectedDevice.deviceType;
    });
  }
}

export interface IDeviceWithCheck extends Device {
  checked: boolean;
}
